import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { I18N } from 'commons';
import { clearPosition } from 'utils/ebUtils';

const CountrySection = ({
  className,
  setFieldValue,
  values: { country },
  countries,
  addresseEditable,
  editable
}) => {
  let fullCountry = country;
  if (!addresseEditable) {
    countries.forEach(item => {
      if (item.code === country) {
        fullCountry = item.value;
      }
    });
  }
  return (
    <div className={className}>
      <label className="col-form-label" htmlFor="country" id="countryLabel">
        <I18N>ssp.countryAndRegion.label</I18N>
      </label>
      <div>
        {
          addresseEditable ?
            <Field
              component="select"
              name="country"
              id="country"
              className="form-control"
              autoComplete="country"
              onChange={e => {
                // set lat & lng empty
                clearPosition({ setFieldValue, name: 'country', value: e.target.value });
                setFieldValue('state', '', false);
              }}
              // cancel the onblur validation
              onBlur={()=>{}}
              disabled={!editable}
              >
              {countries.map(item => (
                <option key={`country-${item.code}`} value={item.code}>
                  {item.value}
                </option>
              ))}
            </Field>
            :
            <Field
              name="country"
              id="country"
              className="form-control"
              value={fullCountry}
              readOnly
          // cancel the onblur validation
              onBlur={()=>{}}
              />
        }
      </div>
    </div>
  );
};

CountrySection.propTypes = {
  values: PropTypes.shape().isRequired,
  countries: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  addresseEditable: PropTypes.bool,
};

CountrySection.defaultProps = {
  addresseEditable: false,
  editable: true
};

export default CountrySection;
